export const USER_UPDATE = 'USER_UPDATE';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR';
export const userUpdate = (updates, showInInfoBar = true, avatarUrl, successMessage) => ({
  type: USER_UPDATE,
  updates,
  errorOptions: {showInInfoBar},
  avatarUrl,
  successMessage
});

export const USER_UPDATE_RESET = 'USER_UPDATE_RESET';
export const userUpdateReset = () => ({type: USER_UPDATE_RESET});

export const USER_AVATARS_FETCH = 'USER_AVATARS_FETCH';
export const USER_AVATARS_FETCH_SUCCESS = 'USER_AVATARS_FETCH_SUCCESS';
export const USER_AVATARS_FETCH_ERROR = 'USER_AVATARS_FETCH_ERROR';
export const userAvatarsFetch = () => ({type: USER_AVATARS_FETCH});

export const USER_AVATARS_CHANGE_ACTIVE = 'USER_AVATARS_CHANGE_ACTIVE';
export const userAvatarsChangeActive = (avatarId) => ({type: USER_AVATARS_CHANGE_ACTIVE, avatarId});




/** WEBPACK FOOTER **
 ** ./src/members/state/user/actions.js
 **/